var _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoccit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300",
      zoom: 1
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n        .st0{fill:none;stroke:#ffffff;stroke-width:12;stroke-miterlimit:8;}\n")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60,60c99.4,0,180,80.6,180,180C140.6,240,60,159.4,60,60z",
    style: {}
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M240,60c-99.4,0-180,80.6-180,180C159.4,240,240,159.4,240,60z",
    style: {}
  })), /*#__PURE__*/React.createElement("text", {
    id: "text1",
    style: {
      fill: "rgb(255, 255, 255)",
      fontFamily: "Helvetica",
      fontSize: 36,
      stroke: "rgb(255, 255, 255)",
      textAnchor: "middle",
      textRendering: "geometricPrecision",
      whiteSpace: "pre"
    },
    x: 156.07,
    y: 162.567
  }, "LOCC\n"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoccit);
export default __webpack_public_path__ + "static/media/loccit.ce78acf6676339221da397a0eb28617f.svg";
export { ForwardRef as ReactComponent };